import { Suspense, memo, useEffect, useState } from 'react'
import React from 'react'
import IconFacebook from '../../assets/icons/icon-gray-facebook.webp'
import IconInstagram from '../../assets/icons/icon-gray-instagram.webp'
import IconLinkedin from '../../assets/icons/icon-gray-linkedin.webp'
import IconYoutube from '../../assets/icons/icon-gray-youtube.webp'
import IconTikTok from '../../assets/icons/tiktok-icon.webp'
import IconSpotify from '../../assets/icons/spotify-icon.webp'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import clsx from 'clsx'
import SkeletonLoading from '../common/SkeletonLoading'

export default memo(Footer)
function Footer() {
  const [widthSidebar, setWidthSidebar] = useState(0)
  const [heightChanges, setHeightChanges] = useState(0)
  const { width } = useWindowDimensions()

  const getWidthSidebar = () => {
    const header = document.querySelector('.sidebar-perfil')
    const width = header?.clientWidth ?? 0
    setWidthSidebar(width + 20)
  }

  const getHeightSaveCancelChanges = () => {
    const header = document.querySelector('.salvar-cancelar-alteracoes')
    const height = header?.clientHeight ?? 0
    setHeightChanges(height + 40)
  }

  useEffect(() => {
    if (window.location.href.includes('/perfil')) {
      if (width > 1023) getWidthSidebar()
      getHeightSaveCancelChanges()
    }
  }, [])

  return (
    <footer
      className={clsx('px-5 text-gray-700 mt-10', {
        'lg:px-[10rem]': widthSidebar <= 0,
        'lg:px-[2rem]': widthSidebar > 0
      })}
      style={{ marginLeft: `${widthSidebar}px`, paddingBottom: `${heightChanges}px` }}
    >
      <hr className="text-[#CCCCCC] border-1 mb-7" />
      <div className="lg:flex">
        <div>
          <div className="lg:flex gap-10">
            <div className="col">
              <h5 className="font-bold text-[20px]">Para Empresas</h5>
              <ul className="list-none w-max text-[18px] font-semibold mt-1">
                <li>
                  <a href="/construtoras-e-incorporadoras">Construtora e incorporadoras</a>
                </li>
                <li>
                  <a href="/parceiros">Parceiros</a>
                </li>
                <li>
                  <a href="/corretores">Corretores</a>
                </li>
                <li>
                  <a href="/imobiliarias">Imobiliárias</a>
                </li>
              </ul>
            </div>
            <div className="mt-5 lg:mt-0">
              <h5 className="font-bold text-[20px]">Para Você</h5>
              <ul className="list-none text-[18px] font-semibold mt-1">
                <li>
                  <a href="/contato">Contato</a>
                </li>
                <li>
                  <a href="https://deportasabertasglemo.com.br/">De Portas Abertas</a>
                </li>
                <li>
                  <a href="https://videocast.glemo.com.br/">Vídeocasts</a>
                </li>
              </ul>
            </div>
            <div className="mt-5 lg:mt-0">
              <h5 className="font-bold text-[20px]">Sobre o glemO</h5>
              <ul className="list-none text-[18px] font-semibold mt-1">
                <li>
                  <a href="/o-glemo">O que é o glemO</a>
                </li>
                <li>
                  <a href="/duvidas-frequentes">Dúvidas frequentes</a>
                </li>
                {/* <li>
                  <a href="/">Sala de imprensa</a>
                </li> */}
              </ul>
            </div>
            {/* <div className="mt-5 lg:mt-0">
              <h5 className="font-bold text-[20px]">Simuladores</h5>
              <ul className="list-none text-[18px] font-semibold mt-1">
                <li>
                  <a href="/simuladores/imovel-ideal">Imóvel Ideal</a>
                </li>
                <li>
                  <a href="/simuladores">Poder de Compra</a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
        <div className="self-end pb-5 mt-5 lg:mt-0 lg:ps-10">
          <div className="grid grid-cols-4 lg:flex lg:gap-4 gap-y-4 md:w-80 lg:w-auto lg:float-right max-w-full">
            <a target='_blank' href="https://www.facebook.com/portalglemo">
              <Suspense fallback={<SkeletonLoading />}>
                <img  alt="Facebook Icon" src={IconFacebook} className="w-[30px] m-auto aspect-square" />
              </Suspense>
            </a>
            <a target='_blank' href="https://www.linkedin.com/company/86467946/admin/">
              <Suspense fallback={<SkeletonLoading />}>
                <img  alt="Linkedin Icon" src={IconLinkedin} className="w-[30px] m-auto aspect-square" />
              </Suspense>
            </a>
            <a target='_blank' href="https://www.instagram.com/portalglemo/">
              <Suspense fallback={<SkeletonLoading />}>
                <img  alt="Instagram Icon" src={IconInstagram} className="w-[30px] m-auto aspect-square" />
              </Suspense>
            </a>
            <a target='_blank' href="https://www.youtube.com/@portalglemo" style={{alignSelf: 'center'}}>
              <Suspense fallback={<SkeletonLoading />}>
                <img  alt="Youtube Icon" src={IconYoutube} className="w-[30px] m-auto aspect-[30/22]" />
              </Suspense>
            </a>
            <a target='_blank' href="https://open.spotify.com/show/66MsHnQI7EVqOgy9TrrgT7?si=3631985369134603" style={{alignSelf: 'center'}}>
              <Suspense fallback={<SkeletonLoading />}>
                <img  alt="Youtube Icon" src={IconSpotify} className="w-[30px] m-auto aspect-auto" />
              </Suspense>
            </a>
            <a target='_blank' href="https://www.tiktok.com/@portalglemo?lang=pt-BR" style={{alignSelf: 'center'}}>
              <Suspense fallback={<SkeletonLoading />}>
                <img  alt="Youtube Icon" src={IconTikTok} style={{filter: 'contrast(0.7)'}} className="w-[30px] m-auto aspect-auto" />
              </Suspense>
            </a>
          </div>
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-2 mt-4">
        <div>
          <p className="text-[18px] text-gray-600">© Open - Todos direitos reservados</p>
        </div>
        <div className="lg:text-right mt-1 lg:mt-0">
          <div>
            <span>
              <a href="/termos-de-uso" className="text-[18px] text-gray-600 underline">
                Termos de uso e Política de privacidade
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}
